module.exports = "build/assets/RingsideRegular-Bold.3dc0ae16.woff2";